import { Expose, Type } from 'class-transformer';
import { Model } from './model';
import { BasicUser } from './basic-user-model';
import { UserType } from '../../common';

export class ContactUsMessages extends Model {
  @Expose() id: string;
  @Expose() isInformed: boolean;
  @Expose() message: string;
  @Expose() response: string;
  @Expose() title: string;
  // toCheck Enums
  @Expose() type: string;
  @Expose()
  @Type(() => BasicUser)
  user: BasicUser;
  @Expose() userType : UserType;
}
